import script from "./Hang-Tag.vue?vue&type=script&setup=true&lang=js"
export * from "./Hang-Tag.vue?vue&type=script&setup=true&lang=js"

import "./Hang-Tag.vue?vue&type=style&index=0&id=c8287ee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8287ee4"]])

export default __exports__